import { PlayerStats } from '../types';

export type PowerUpKind =
  | 'bomb'
  | 'range'
  | 'speed'
  | 'remote'
  | 'kick'
  | 'pierce'
  | 'shield'
  | 'life'
  | 'score';

export interface PowerUpSpec {
  kind: PowerUpKind;
  textureKey: string;
  weight: number;     // for weighted random pick
  apply: (stats: PlayerStats, awardLife: () => void, awardScore: (n: number) => void) => void;
}

export const POWERUPS: Record<PowerUpKind, PowerUpSpec> = {
  bomb: {
    kind: 'bomb', textureKey: 'pu-bomb', weight: 22,
    apply: (s) => { s.bombCount = Math.min(8, s.bombCount + 1); },
  },
  range: {
    kind: 'range', textureKey: 'pu-range', weight: 22,
    apply: (s) => { s.bombRange = Math.min(7, s.bombRange + 1); },
  },
  speed: {
    kind: 'speed', textureKey: 'pu-speed', weight: 13,
    apply: (s) => { s.speedLevel = Math.min(5, s.speedLevel + 1); },
  },
  remote: {
    kind: 'remote', textureKey: 'pu-remote', weight: 10,
    apply: (s) => { s.hasRemote = true; },
  },
  kick: {
    kind: 'kick', textureKey: 'pu-kick', weight: 9,
    apply: (s) => { s.hasKick = true; },
  },
  pierce: {
    kind: 'pierce', textureKey: 'pu-pierce', weight: 7,
    apply: (s) => { s.hasPierce = true; },
  },
  shield: {
    kind: 'shield', textureKey: 'pu-shield', weight: 7,
    apply: (s) => { s.hasShield = true; },
  },
  life: {
    kind: 'life', textureKey: 'pu-life', weight: 5,
    apply: (_s, awardLife) => { awardLife(); },
  },
  score: {
    kind: 'score', textureKey: 'pu-score', weight: 5,
    apply: (_s, _l, awardScore) => { awardScore(5000); },
  },
};

// Probability that a destroyed soft block drops a power-up.
export const POWERUP_DROP_CHANCE = 0.55;

export function pickRandomPowerUp(): PowerUpSpec {
  const list = Object.values(POWERUPS);
  const total = list.reduce((s, p) => s + p.weight, 0);
  let r = Math.random() * total;
  for (const p of list) {
    r -= p.weight;
    if (r <= 0) return p;
  }
  return list[0];
}
